import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {
        return useAuthUserStore().getApiClient.get('/reports/sales/monthly', {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}